import './styles/bootstrap.scss'
import React, {lazy} from 'react'
import ReactDOM from 'react-dom/client'
import {AppContentWrapper} from './AppContentWrapper'
import CurrentConfig from './Config'
import './index.css'
import './App.css'

const AppDomaAI = lazy(() => {
    return import('./AppDomaAI')
})
const AppInternal = lazy(() => {
    return import('./AppInternal')
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <React.StrictMode>
        {CurrentConfig.DOMA_AI ? (
            <AppContentWrapper>
                <AppDomaAI />
            </AppContentWrapper>
        ) : (
            <AppInternal />
        )}
    </React.StrictMode>
)
